import React from "react";
import { useTranslation } from "react-i18next";
import { useParallax } from "react-scroll-parallax";

import { SectionIds } from "@constants/sectionIds";
import { eventsLinks } from "@constants/eventsLinks";

import { ReactComponent as IconLink } from "@images/icons/icon-link.svg";
import BaseLink from "@components/toolkit/BaseLink/BaseLink";

import "./SystemSkeyTix.scss";

const SystemSkeyTix = () => {
  const { t } = useTranslation("landingPage");

  const { ref } = useParallax({
    speed: -15,
    scale: [1.05, 1, "easeOutCubic"]
  });

  return (
    <section id={SectionIds.SystemSkeyTix} className="system-skey-tix">
      <div className="system-skey-tix-background">
        <img
          ref={ref as any}
          src="/images/layouts/system-skey-tix-bg.jpg"
          alt="System Skey Tix - conference"
          className="bg-image"
        />
        <div className="bg-blur" />
      </div>

      <div className="system-skey-tix-main">
        <div className="main-content">
          <h2>{t("systemSkeyTix.title")}</h2>
          <p className="p0 mt-8 white-space-pre-wrap">{t("systemSkeyTix.description")}</p>

          <div className="example-events">
            <p className="p0 mt-8">{t("systemSkeyTix.exampleSite.title")}</p>

            <ul className="events-list">
              {eventsLinks.map(({ label, href, target }, index) => (
                <li key={index}>
                  <BaseLink href={href} target={target}>
                    {t(label as any)} <IconLink />
                  </BaseLink>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="main-schema-box">
          <img src="/images/layouts/system-skey-tix-schema.svg" alt="System Skey Tix schema" className="image-schema" />
        </div>
      </div>
    </section>
  );
};

export default SystemSkeyTix;
